import { ChevronLeft, ChevronRight, Filter } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

import { api, formatApiError } from "@/lib/api";


const formatTimestamp = (value) => new Intl.DateTimeFormat("id-ID", {
  dateStyle: "medium",
  timeStyle: "medium",
}).format(new Date(value));

export default function AuditLogsPage() {
  const [data, setData] = useState({ records: [], page: 1, page_size: 25, total: 0 });
  const [filters, setFilters] = useState({ action: "", user_email: "", store_id: "", status: "" });
  const [error, setError] = useState("");

  const loadLogs = useCallback(async (page = 1) => {
    setError("");
    try {
      const response = await api.get("/audit", { params: { ...filters, page } });
      setData(response.data);
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  }, [filters]);

  useEffect(() => {
    loadLogs();
  }, [loadLogs]);

  const applyFilters = (event) => {
    event.preventDefault();
    loadLogs(1);
  };

  return (
    <main className="workspace" data-testid="audit-page">
      <section className="page-heading"><div><p className="eyebrow">JEJAK AKTIVITAS</p><h1 data-testid="audit-page-title">Audit log</h1></div></section>
      {error && <p className="form-error" data-testid="audit-error" role="alert">{error}</p>}
      <section className="form-section" aria-labelledby="audit-filter-title">
        <div className="section-heading"><div><p className="eyebrow">FILTER</p><h2 id="audit-filter-title">Cari aktivitas</h2></div></div>
        <form className="audit-filter-form" data-testid="audit-filter-form" onSubmit={applyFilters}>
          <input data-testid="audit-action-filter" onChange={(event) => setFilters({ ...filters, action: event.target.value })} placeholder="Aksi, mis. login" value={filters.action} />
          <input data-testid="audit-email-filter" onChange={(event) => setFilters({ ...filters, user_email: event.target.value })} placeholder="Email pengguna" type="email" value={filters.user_email} />
          <select data-testid="audit-status-filter" onChange={(event) => setFilters({ ...filters, status: event.target.value })} value={filters.status}>
            <option value="">Semua status</option><option value="success">Sukses</option><option value="failed">Gagal</option>
          </select>
          <button className="form-action" data-testid="audit-filter-submit-button" type="submit"><Filter aria-hidden="true" size={16} /> Terapkan</button>
        </form>
      </section>
      <section className="data-section" aria-labelledby="audit-records-title">
        <div className="section-heading"><div><p className="eyebrow">{data.total} CATATAN</p><h2 id="audit-records-title">Aktivitas terbaru</h2></div></div>
        <div className="audit-list" data-testid="audit-record-list">
          {data.records.map((record, index) => (
            <article data-testid={`audit-record-${index}`} key={`${record.created_at}-${index}`}>
              <time>{formatTimestamp(record.created_at)}</time><strong>{record.action}</strong><span>{record.user_email || "Pengunjung"}</span><span>{record.store_name || "—"}</span><span className={`state-chip ${record.status === "success" ? "active" : "inactive"}`}>{record.status}</span>
            </article>
          ))}
        </div>
        <div className="pagination-controls" data-testid="audit-pagination-controls">
          <button className="icon-button" data-testid="audit-previous-page-button" disabled={data.page <= 1} onClick={() => loadLogs(data.page - 1)} title="Halaman sebelumnya" type="button"><ChevronLeft aria-hidden="true" size={17} /></button>
          <span data-testid="audit-page-indicator">Halaman {data.page}</span>
          <button className="icon-button" data-testid="audit-next-page-button" disabled={data.page * data.page_size >= data.total} onClick={() => loadLogs(data.page + 1)} title="Halaman berikutnya" type="button"><ChevronRight aria-hidden="true" size={17} /></button>
        </div>
      </section>
    </main>
  );
}